<template>
  <el-dialog
    :visible="dialogVisible"
    :title="'创建商品'"
    width="500px"
    :before-close="handleClose"
    class="customDialogForm"
  >
    <el-form
      ref="productForm"
      :model="productForm"
      :rules="rules"
    >
      <el-form-item label="商品名称" prop="name" :label-width="formLabelWidth">
        <el-input
          v-model="productForm.name"
          placeholder="请输入商品名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="应用分类" prop="categoryID" :label-width="formLabelWidth">
        <el-select
          v-model="productForm.categoryID"
          placeholder="请选择应用分类"
          clearable

          style="margin-bottom: 0"
        >
          <el-option
            v-for="item in categoryList"
            :key="item.appClassificationID"
            :label="item.appClassificationName"
            :value="item.appClassificationID"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="商品简介" prop="introduction" :label-width="formLabelWidth">
        <el-input
          v-model="productForm.introduction"
          type="textarea"
          :rows="2"
          placeholder="请输入商品简介"
        ></el-input>
      </el-form-item>

      <el-form-item label="应用Logo" prop="logo" :label-width="formLabelWidth">
        <div style="display: flex; align-items: flex-start;">
          <el-upload
            class="avatar-uploader"
            :action="uploadConfig.api"
            :with-credentials="true"
            :headers="uploadConfig.headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="productForm.logo" :src="productForm.logo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <i v-if="productForm.logo" class="el-icon-delete" @click.stop="handleRemove"></i>
          </el-upload>
          <span class="upload-tip">
            建议上传 100*100 比例的Logo
          </span>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
type="primary"
:loading="loading"
@click="handleSubmit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { errorHandle } from '../../../../utils/error';
import { getToken } from '@/utils/auth';

export default {
  name: 'CreateProduct',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    marketID: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      default: null
    },
    onSuccess: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      loading: false,
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      productForm: {
        name: '',
        categoryID: '',
        logo: '',
        introduction: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          {
            min: 2,
            max: 200,
            message: '长度在 2 到 200 个字符',
            trigger: 'blur'
          }
        ],
        introduction: [
          { required: false, message: '请输入商品简介', trigger: 'blur' }
        ],
        categoryID: [
          { required: false, message: '请选择应用分类', trigger: 'change' }
        ]
      },
      formLabelWidth: '80px'
    };
  },
  computed: {
    currentUserInfo() {
      return this.$store.state.user.userInfo;
    },
    categoryList() {
      return this.$store.state.product.categoryList || [];
    }
  },
  watch: {
    product: {
      handler(val) {
        if (val) {
          this.productForm = {
            name: val.name || '',
            categoryID: val.categoryID || '',
            logo: val.logo || '',
            introduction: val.introduction || ''
          };
        }
      },
      immediate: true
    },
    dialogVisible: {
      handler(val) {
        if (val && this.categoryList.length === 0) {
          // 当对话框打开且分类列表为空时,加载分类列表
          this.fetchCategoryList();
        }
      },
      immediate: true
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.productForm.logo = res.FileURL;
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.warning(
          '上传图片类型不支持,请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.warning('上传失败!');
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.warning('上传Logo图片只能是JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.warning('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPng) && isLt2M;
    },
    handleRemove() {
      this.$confirm('是否删除logo', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.productForm.logo = '';
      });
    },
    fetchCategoryList() {
      this.$store
        .dispatch('GetCategoryList', {
          marketID: this.marketID,
          disableTree: true
        })
        .catch((err) => {
          console.error('获取分类列表失败:', err);
        });
    },
    handleClose() {
      this.$refs.productForm.resetFields();
      this.onClose();
    },
    handleSubmit() {
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const action = this.product ? 'UpdateProduct' : 'CreateProduct';
          const params = {
            marketID: this.marketID,
            ...this.productForm
          };

          // 创建时需要传userID
          if (!this.product) {
            params.userID = this.currentUserInfo.userID;
          }

          // 编辑时需要传productID
          if (this.product) {
            params.productID = this.product.productID;
          }

          // 清理空字符串字段
          Object.keys(params).forEach(key => {
            if (params[key] === '') {
              delete params[key];
            }
          });

          this.$store
            .dispatch(action, params)
            .then((res) => {
              if (res) {
                this.$message({
                  type: 'success',
                  message: this.product ? '商品更新成功' : '商品创建成功'
                });
                this.onSuccess();
              }
              this.loading = false;
            })
            .catch((err) => {
              errorHandle(err);
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
::v-deep .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 30px 20px;
}

::v-deep .el-form-item {
  margin-bottom: 22px;
}

::v-deep .el-form-item__label {
  color: #606266;
  font-weight: 500;
}

::v-deep .el-input__inner {
  border-radius: 4px;
}

::v-deep .el-textarea__inner {
  border-radius: 4px;
}

::v-deep .el-select {
  width: 100%;
}

.avatar-uploader {
  position: relative;
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  display: block;
  background-color: #fafafa;
  transition: all 0.3s;
}

.avatar-uploader:hover .avatar-uploader-icon {
  color: #409EFF;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  object-fit: cover;
}

.el-icon-delete {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 18px;
  color: #fff;
  background: rgba(245, 108, 108, 0.9);
  padding: 4px;
  border-radius: 0 5px 0 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.el-icon-delete:hover {
  background: rgba(245, 108, 108, 1);
}

.upload-tip {
  color: #999999;
  font-size: 12px;
  line-height: 1.5;
  margin-left: 12px;
  margin-top: 4px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/productManage/components/createProduct.vue